import { countries } from '../constants/countries';
import { AU_STATES, US_STATES } from '../constants/country-admin-divisions';

export const getFullCountryName = value => {
  if (!value) return null;

  const lowerValue = value.toLowerCase();

  // Alpha-2 code match
  if (value.length === 2) {
    const match = countries.find(c => c.alpha2?.toLowerCase() === lowerValue);
    return match?.value ?? value;
  }

  // Full name match
  if (value.length > 3) {
    const match = countries.find(c => c.value.toLowerCase() === lowerValue);
    return match?.value ?? value;
  }

  // Alpha-3 code match
  if (value.length === 3) {
    const match = countries.find(c => c.alpha3?.toLowerCase() === lowerValue);
    return match?.value ?? value;
  }

  return value;
};

export const getFullStateName = (stateCode, countryCode) => {
  if (!stateCode) return null;

  const lowerStateCode = stateCode.toLowerCase();
  const lowerCountryCode = countryCode?.toLowerCase();

  // Try Australian states first
  if (lowerCountryCode === 'au' || !countryCode) {
    const auMatch = AU_STATES.find(state => state.value.toLowerCase() === lowerStateCode);
    if (auMatch) return auMatch.name;
  }

  // Try US states
  if (lowerCountryCode === 'us' || !countryCode) {
    const usMatch = US_STATES.find(state => state.value.toLowerCase() === lowerStateCode);
    if (usMatch) return usMatch.name;
  }

  // If no match found, return original value
  return stateCode;
};
